/**
 * Import all front-end JS scripts.
 * 
 * Compiles to assets/scripts/theme-scripts.js
 */

 /* eslint-disable no-unused-vars */

// Import Bootstrap JS and Popper
import "../../../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";


 // Import ES6 modules (recommended)
 // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
import "./base/menu-level.js";
import "./base/search-toggle.js";
import mainNavigation from './base/main-navigation';


// Or import entire JS files the "old school" way
// import './test.js'